import React, { useState, useEffect, Fragment } from 'react'
import axios from 'axios';
import { motion } from 'framer-motion'
import imgSvg  from '../../assets/backgroundImage.svg'
import ShopingCard from '../shopingCard/shopingCard'
import MenuHome from './menuHome/menuHome'
import dataProductLit from './shwowProductsHome/dataProducts'
import MainShowProductHome from './shwowProductsHome/mainShowProductsHome'
import ImgPresentationHome from './wavesHome/imgPresentationHome';

import URL from '../config/config-server-api';
import './homeContent.css'

const HomeConent =({handleDatTienda})=>{


    // console.log(TIENDA)
    // almace los productos gregados al carrito de compras
    const [shoppingCart, setShoppingCart] = useState([]);
    // state of modal detail 
    const [stateViewdDetail,setStateViewdDetail] = useState(false);

    // almacena todos los productos de la tienda
    const [TIENDA, setTIENDA] = useState({})

    const [category, setCategory] =useState([])
    
    // hots que cargas los datosiniciales de la tienda
    useEffect(()=>{

        peticionAlaApi();

    },[])



    const peticionAlaApi = async(cantRequests=0)=>{
        try {

            var url = `${URL.UrlShowAllProductsTienda}${process.env.REACT_APP_ID_TIENDA}&order=desc`;
            console.log(url);
            const { data } = await axios.get(url);
            // console.log(data);
            setTIENDA(data);
            handleDatTienda(data);
            setCategory(data.listProducts)
        } catch (error) {
            // console.log('---------')
            // console.log(cantRequests);
            // console.log(error)
            if(cantRequests>=5)return;
            peticionAlaApi(cantRequests+1)
        }

    }

    // saca todas las taregorias
    const handleCategory = async(nameCategory)=>{
        
        console.log(nameCategory);
        if(TIENDA.listProducts.length===0  || TIENDA.listProducts === undefined)return nameCategory;
        if(nameCategory==='todo')return setCategory(TIENDA.listProducts)
        var aux = await TIENDA.listProducts.filter(product=>product.category === nameCategory)
        setCategory(aux)
    }


    const handleStateViewdDetail=()=>{
        setStateViewdDetail(!stateViewdDetail)
    }


    const handleShoppingCart=async(dataProd)=>{
        // console.log('product add-shoping cart');
        // console.log(dataProd)
        // console.log(dataProd._id)
        // console.log('----end ')

        if(shoppingCart.length>0){
           
             const data = await  seachProducExisten(dataProd);
            //  console.log('**************')
            //  console.log(data)
            //  console.log('**************')
             if(data===false){
                dataProd.cantidad = 1;
                setShoppingCart([
                    ...shoppingCart,
                    dataProd
                ])
             }
        
        }else{
            
             dataProd.cantidad = 1;
             setShoppingCart([
                 ...shoppingCart,
                 dataProd
             ])

        }


    }

    const seachProducExisten=async(dataProd)=>{
        var aux=false;
        await shoppingCart.map(product=>{
            // console.log(product._id);
            // console.log(dataProd._id)
            if(product._id === dataProd._id){

              aux= true;
            }
        })
        return aux
        
    }

    const remoreProductShoppingCard =async ({item})=>{
        if(shoppingCart.length>0){
            var ProductList = [];
            await shoppingCart.map((d,i)=>{
                if(i!==item){
                    ProductList=[...ProductList,d];
                }
            })
            setShoppingCart(ProductList)
        }
    }

    const handleCantidad= async(operacion, product)=>{
        // console.log('--handlechange---')
        // console.log(operacion)
        // console.log(product)
        var productsCart =[];
        if(operacion){
            productsCart=await shoppingCart.map((d,i)=>{
                if(d._id===product._id){
                    d.cantidad++;
                }
                return d;
            })
        }else{
            productsCart=await shoppingCart.map((d,i)=>{
                if(d._id===product._id){
                    
                    d.cantidad--;
                }
                return d;
            })
        }
        setShoppingCart(productsCart)
    }

    const products = [
        {
            urlImage:'1',
            nameProducts:'Razer mamba   wireless mouse',
            vendedor: 'Vendedor: Latin Tienda',
            precio: 'Bs. 688.00'
        },{
            urlImage:'2',
            nameProducts:'Razer mamba wireless mouse',
            vendedor: 'Vendedor: Latin Tienda',
            precio: 'Bs. 688.00'
        },{
            urlImage:'3',
            nameProducts:'Razer mamba wireless mouse',
            vendedor: 'Vendedor: Latin Tienda',
            precio: 'Bs. 688.00'
        },{
            urlImage:'4',
            nameProducts:'Razer mamba wireless mouse',
            vendedor: 'Vendedor: Latin Tienda',
            precio: 'Bs. 688.00'
        },{
            urlImage:'5',
            nameProducts:'Razer mamba wireless mouse',
            vendedor: 'Vendedor: Latin Tienda',
            precio: 'Bs. 688.00'
        },{
            urlImage:'6',
            nameProducts:'Razer mamba wireless mouse',
            vendedor: 'Vendedor: Latin Tienda',
            precio: 'Bs. 688.00'
        },{
            urlImage:'7',
            nameProducts:'Razer mamba wireless mouse',
            vendedor: 'Vendedor: Latin Tienda',
            precio: 'Bs. 688.00'
        }
    ]

    const bgImg=(srcImag)=>{

        return ({
            position:'relative',
            backgroundImage:`url(${srcImag})`,
            backgroundSize:'cover',
            // filter:'blur(3px)',
            // zIndex:'1'
        })
    }

    const listCategory=[1,2,3,4,5,6,7,8,9]

    return(
        <Fragment>
           <div className="w-full bg-gray-200">
    
               <div className="bg-white mx-auto w-full lg:w-5/6 px-0 lg:px-10 pt-14 ">
               {/* style={bgImg(TIENDA?.fotoLugar)}  */}
                    <div id="image-presentation" className=" h-60 sm:h-96  w-full flex p-0 md:p-1">
                        <div  style={bgImg(TIENDA?.fotoLugar?TIENDA?.fotoLugar:'https://mybuecket-test1.s3.amazonaws.com/loaging-poster-img.gif')} className="bg-image bg-gray-200 bg-opacity-70  mx-auto flex inline-flex items-center justify-center h-full w-screen md:h-full rounded-none sm:rounded-2xl">
                            <ImgPresentationHome   fotoLugar={TIENDA?.fotoLugar}></ImgPresentationHome>
                        </div>
                    </div>
                    {/* shop-Logo */}
                    <div id="content-logo-tienda" className="content flex flex-rows-1 mx-6 sm:mx-10 rounded-lg">
                            <motion.div id="img-content" initial={{opacity:0,x:90}} animate={{opacity:1,x:0}} className="bg-gray-100 rounded-lg w-20 h-20">
                                <img src={TIENDA?.logo?TIENDA.logo:'https://mybuecket-test1.s3.amazonaws.com/loading-card-img.gif'}alt="" className="h-20 w-20" />
                            </motion.div>
                            {/* name shop */}
                            <div className=" uppercase font-extrabold flex flex-justify-center pl-2">
                                    <motion.h1 initial={{opacity:0}} animate={{opacity:1}} transition={{duration:3}} className="my-auto">{TIENDA?.nameNegocio}</motion.h1>
                            </div>
                    </div>

                    <section className=" mx-2 sm:mx-10 my-10">
                        <div id="content-category" className=" flex flex-rows-1 ">
                            {
                                TIENDA.allCategories?
                                <motion.div className="relative ml-3 my-2 mr-5">
                                    <motion.div id="container-img-category" onClick={()=>handleCategory('todo')} whileHover={{scale:1.05}} whileTap={{scale:0.9}}  className="bg-gray-800 p-1 rounded-full mx-auto  w-24 h-24">
                                        <div id="content-img" className="m-0 rounded-full w-full h-full bg-gray-100">
                                            <img id="img-category"  height="40" width="100"  className="rounded-full"  src={TIENDA?.logo?TIENDA.logo:'https://mybuecket-test1.s3.amazonaws.com/loading-card-img.gif'} alt="" />
                                        </div>
                                    </motion.div>
                                    <div className="text-center capitalize text-gray-700 w-auto">
                                        Todo
                                    </div>
                                </motion.div>
                                :''
                            }
                            {
                            
                                TIENDA.allCategories?
                                TIENDA.allCategories.map((d,i)=>{
                                    return <div key={d.nameProduct} className="relative my-2  mr-5">
                                                <motion.div id="container-img-category"  onClick={()=>handleCategory(d.category)} whileHover={{scale:1.05}} whileTap={{scale:0.9}} className="bg-gray-800  rounded-full mx-auto  w-24 h-24">
                                                   <div id="content-img" className="m-0 rounded-full w-full h-full bg-gray-100">
                                                       <img id="img-category"  className="rounded-full"  src={d.fotoProducto} alt="" />
                                                   </div>
                                                </motion.div>
                                                <div className="text-center capitalize text-gray-700 w-20  sm:w-36">
                                                    {d?.category?.replace(/-/g,' ')}
                                                </div>
                                            </div>
                                })
                                :
                                listCategory.map((d,i)=>{
                                    return <div key={d.nameProduct} className="relative my-2  mr-5">
                                                <motion.div id="container-img-category-load"  onClick={()=>handleCategory(d.category)} whileHover={{scale:1.05}} whileTap={{scale:0.9}} className="bg-gray-800 p-1 rounded-full mx-auto  w-24 h-24">
                                                   <div id="content-img" className="m-0 rounded-full w-full h-full bg-gray-100">
                                                       <img id="img-category"  className="rounded-full"  src="https://mybuecket-test1.s3.amazonaws.com/loading-card-img.gif" alt="" />
                                                   </div>
                                                </motion.div>
                                                <div className="text-center capitalize text-white w-20  sm:w-36">
                                                    {d}
                                                </div>
                                            </div>
                                })
                            }
                        </div>
                    </section>
                    
                        {/* show list products */}
                    {/* <section>
                            <div>
                                {   category.length!=0?
                                    category.map((d,i)=>{
                                        return <ul key={d?.nameProduct}>
                                            <li>{d.nameProduct}</li>
                                        </ul>
                                    })
                                    :''
                                }
                            </div>
                    </section> */}

                    <section className="mt-2 pb-40">
                        <MainShowProductHome 
                        // category={'Productos recien agregados'} 
                        category={category} 
                        shoppingCart={shoppingCart} 
                        handleShoppingCart={handleShoppingCart} 
                        handleStateViewdDetail={handleStateViewdDetail} 
                        TIENDA={TIENDA} />
                    </section>
              
               </div>
           </div>

            
           <ShopingCard shoppingCart={shoppingCart} setShoppingCart={setShoppingCart} remoreProductShoppingCard={remoreProductShoppingCard} handleCantidad={handleCantidad} handleStateViewdDetail={handleStateViewdDetail} stateViewdDetail={stateViewdDetail} TIENDA={TIENDA} />

        </Fragment>
    )
}

export default HomeConent;